import { ScheduleOverride, ScheduledOrder } from "../api/trucks/timeframes";
import moment from "moment";

export class TruckOptimizationOrder {
  constructor(order: ScheduledOrder) {
    this.crn = order.orderInfo.customerReferenceNumber;

    if (order.orderInfo.address) {
      let streetAddress = order.orderInfo.address.streetLine1;

      if (order.orderInfo.address.streetLine2) streetAddress += order.orderInfo.address.streetLine2;

      this.streetAddress = streetAddress;
      this.city = order.orderInfo.address.city;
      this.state = order.orderInfo.address.state;
      this.zip = order.orderInfo.address.zip;
    }

    this.sequenceNumber = order.orderInfo.sequenceNumber;
    this.orderHeaderNumber = order.orderInfo.orderHeaderNumber;
    this.travelTime = order.travelTime;
    this.overheadTime = order.overheadTime;
    this.unloadTime = order.unloadTime;
    this.estimatedArrival = order.estimatedArrivalDateTime;
    this.earliestArrival = order.earliestDateTime;
    this.latestArrival = order.latestDateTime;
    this.truckDetailId = order.orderInfo.truckDetailId;
    this.travelMiles = order.travelMiles;

    if (order.anticipatedArrivalDateTime) {
      this.anticipatedArrival = moment(order.anticipatedArrivalDateTime).format();
    }

    if (order.override) {
      if (order.override.overrideOverheadTime) {
        this.overheadTimeOriginal = this.overheadTime;
        this.overheadTime = order.override.overrideOverheadTime;
        this.overheadTimeOverride = true;
      }

      if (order.override.overrideTravelTime) {
        this.travelTimeOriginal = this.travelTime;
        this.travelTime = order.override.overrideTravelTime;
        this.travelTimeOverride = true;
      }

      if (order.override.overrideUnloadTime) {
        this.unloadTimeOriginal = this.unloadTime;
        this.unloadTime = order.override.overrideUnloadTime;
        this.unloadTimeOverride = true;
      }

      if (order.override.anticipatedArrivalDateTime) {
        this.anticipatedArrival = moment(order.override.anticipatedArrivalDateTime).format();
        this.anticipatedArrivalOverride = true;
      }
    }
  }
  truckDetailId: number;
  crn: string;
  streetAddress: string;
  city: string;
  state: string;
  zip: string;
  sequenceNumber: number;
  orderHeaderNumber: number | null;
  nonCdsOrderId?: string | null;
  estimatedArrival: Date;
  earliestArrival: Date;
  latestArrival: Date;
  travelTime: string;
  travelTimeOverride: boolean;
  travelTimeOriginal: string;
  overheadTime: string;
  overheadTimeOriginal: string;
  overheadTimeOverride: boolean;
  unloadTime: string;
  unloadTimeOriginal: string;
  unloadTimeOverride: boolean;
  anticipatedArrival: string | null;
  anticipatedArrivalOriginal: string;
  anticipatedArrivalOverride: boolean;
  travelMiles: number;
}
